import React from 'react';
import './style.scss';

interface AgregNumberProps {
  value?: number;
}

export const AgregNumber: React.FC<AgregNumberProps> = ({ value }) => {
  return !value || value === 0 ? null : <div className="agreg-number">{value}</div>;
};
